import { UseFormReturn } from "react-hook-form";
import { TaskStatus } from "./definitions";
import { format } from "date-fns";

export const handleStatusChange = (
  newStatusString: string | undefined,
  previousStatus: string,
  formMethods: UseFormReturn<any>
): string => {
  if (!newStatusString) {
    return previousStatus;
  }
  const currentDate = format(new Date(), "yyyy-MM-dd");
  const currentStartDate = formMethods.watch("actualStartDateString");
  const currentCompletionDate = formMethods.watch("actualCompletionDateString");

  if (newStatusString === TaskStatus.InProgress) {
    if (!currentStartDate) {
      formMethods.setValue("actualStartDateString", currentDate);
    }
    formMethods.setValue("actualCompletionDateString", "");
  } else if (newStatusString === TaskStatus.Complete) {
    if (currentStartDate || previousStatus === TaskStatus.InProgress) {
      // Preserve the existing start date
    } else {
      formMethods.setValue("actualStartDateString", "");
    }

    if (!currentCompletionDate) {
      formMethods.setValue("actualCompletionDateString", currentDate);
    }
  } else {
    formMethods.setValue("actualStartDateString", "");
    formMethods.setValue("actualCompletionDateString", "");
  }
  return newStatusString;
};
